import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fromDate", "toDate"]

  connect() {
    this.fromDateTarget.addEventListener('change', this.checkRange.bind(this))
    this.toDateTarget.addEventListener('change', this.checkRange.bind(this))

    this.checkRange();
  }

  checkRange() {
    const fromValue = this.fromDateTarget.value
    const toValue = this.toDateTarget.value

    const today = new Date()
    const year = today.getFullYear()
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    const maxDateTime = `${year}-${month}-${day}T00:00:00`
    
    this.fromDateTarget.max = maxDateTime
    this.toDateTarget.max = maxDateTime
    
    if (fromValue) {
      this.toDateTarget.min = fromValue
      
      if (toValue && toValue < fromValue) {
        this.toDateTarget.value = fromValue
      }
    }
    
    // Check if selected dates are in the future and adjust if needed (in case someone tries to loads wrogn dates through URL parameters)
    if (fromValue && fromValue > maxDateTime) {
      this.fromDateTarget.value = maxDateTime
    }
    
    if (toValue && toValue > maxDateTime) {
      this.toDateTarget.value = maxDateTime
    }
  }
}